module.exports = __webpack_public_path__ + "static/media/uj_szerzigeny1.afc105f9.jpg";